import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  applyActionCode,
  signOut,
  connectAuthEmulator,
} from "firebase/auth";
import {
  getFirestore,
  connectFirestoreEmulator,
} from "firebase/firestore";
import {
  getFunctions,
  connectFunctionsEmulator
} from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBLaUSDw45JGnsdcFJpGYYI6nWgKc-ed-w",
  authDomain: "twodata-dev.firebaseapp.com",
  projectId: "twodata-dev",
  storageBucket: "twodata-dev.appspot.com",
  messagingSenderId: "407316078017",
  appId: "1:407316078017:web:6b76d094555a8e2d056340",
  measurementId: "G-1R262ZRWJV",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const functions = getFunctions(app, 'europe-west3');
const chatFunctions = getFunctions(app, 'europe-west3');
const storage = getStorage(app);
const db = getFirestore(app);

const isLocalEnv =
  process.env.REACT_APP_APP_ENV === 'local' ||
  process.env.APP_ENV === 'local' ||
  process.env.REACT_APP_ENABLE_E2E_HARNESS === 'true';

if (isLocalEnv) {
  try {
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
  } catch (e) {}
  try {
    connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  } catch (e) {}
  try {
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
    connectFunctionsEmulator(chatFunctions, "127.0.0.1", 5001);
  } catch (e) {}
  try {
    connectStorageEmulator(storage, "127.0.0.1", 9199);
  } catch (e) {}
}

const logInWithEmailAndPassword = async (email: string, password: string) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (err) {
    alert("Login failed. Please provide a valid username and password.");
  }
};

const sendPasswordReset = async (email: string) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent!");
  } catch (err) {
    console.error(err);
    alert((err as any).message);
  }
};

const logout = async () => {
  await signOut(auth);
};


export {
  app as firebaseApp,
  auth,
  db,
  functions,
  chatFunctions,
  storage,
  logInWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordReset,
  applyActionCode,
  logout,
};
